import { postRequest } from '@/utils/request';
import * as http from '@/utils/request-silence';
var api = process.env['VUE_APP_LAW_API'];

/**
 * 关联法规
 * @param data = {answer: 'xxxx'}
 * @return {AxiosPromise}
 */
export var getRecommendLaw = function getRecommendLaw() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    answer: ''
  };
  return postRequest('/library/rag/compliance-policy/recommend', data, {
    baseUrl: api
  });
};

/**
 * 法规详情
 * @param data
 * @returns {AxiosPromise}
 */
export var getLawDetailById = function getLawDetailById() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    id: '',
    isShare: 1
  };
  return postRequest('/biz/statuteInfo/getDetailById', data, {
    baseUrl: api
  });
};

/**
 * 问题引导
 * @param data
 * @returns {AxiosPromise}
 */
export var getLawQuestionGuidance = function getLawQuestionGuidance() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return http.postRequest('/biz/taxLawsAI/tax-Laws/question-Guidance', data, {
    baseUrl: api
  });
};

/**
 * 生成预分享信息
 * @param data
 * @returns {AxiosPromise}
 */
export var generatePreviewShareInfo = function generatePreviewShareInfo() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return http.postRequest('/shareRecord/genSharePre', data, {
    baseUrl: api
  });
};

/**
 * 临时保存分享记录
 * @param data
 * @returns {AxiosPromise}
 */
export var saveShareRecord = function saveShareRecord() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return http.postRequest('/shareRecord/saveShareRecord', data, {
    baseUrl: api
  });
};

/**
 * 通过分享码查询
 * @param shareCode
 * @returns {AxiosPromise}
 */
export var getRecordByShareCode = function getRecordByShareCode(shareCode) {
  return http.getRequest("/shareRecord/getByShareCode/".concat(shareCode, " "), {}, {
    baseUrl: api
  });
};